import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ImportService } from '../../../services/import.service';
import { UserService } from '../../../services/user.service';
import { MappedHeader } from '../../../models/mapped-header';
import { SnackBarService } from '../../../services/snack-bar.service';
import { MatDialog } from '@angular/material/dialog';
import { MapAllShowsErrorModalComponent } from '../../_modals/map-all-shows-error-modal/map-all-shows-error-modal.component';
import { ImportingSelectionsModalComponent } from '../../_modals/importing-selections-modal/importing-selections-modal.component';
import { ProLabelMappingProfile } from 'src/app/shared/models/pro-label-mapping-profile';
import { P } from '@angular/cdk/keycodes';
import { ProMappedHeaders } from 'src/app/shared/models/pro-mapped-headers';
import { Router } from '@angular/router';
import { PartnerService } from 'src/app/shared/services/partner.service';
import { ShowMapperProfile } from 'src/app/shared/models/show-mapper-profile';

@Component({
  selector: 'app-pro-import-map-submit-header',
  templateUrl: './pro-import-map-submit-header.component.html',
  styleUrls: ['./pro-import-map-submit-header.component.scss']
})
export class ProImportMapSubmitHeaderComponent implements OnInit {

  @Output() mappingStart = new EventEmitter<void>();
  @Output() mappingEnd = new EventEmitter<void>();

  //determines what step of the import process we are on
  @Input() activeStep: any;

  breadcrumbs = [];

  importedFilePath: string;

  showMapHeaders: boolean;

  isOnMapHeadersView: boolean = false;

  importType: string;

  // for Super Admin use only
  mappedHeaders: MappedHeader[] = [];

  approvedLabels: string[] = [];

  mappedPartnerPros: any[] = [];

  savedMappingProfile: ProLabelMappingProfile | null;

  isMapping = false;

  constructor(private importService: ImportService, private partnerService: PartnerService, public userService: UserService, private snackbarService: SnackBarService, public dialog: MatDialog, private router: Router) { }

  ngOnInit() {
    //breadcrumbs for header
    this.breadcrumbs = this.importService.breadcrumbs;

    // //Track active step on the breadcrumbs
    // this.importService.breadCrumbActiveStep$.subscribe((x) => {
    //   this.activeStep = x;
    // });

    //Track the file path of the recently stored import pro file
    this.importService.importedFilePath$.subscribe((x) => {
      this.importedFilePath = x;
    });

    //Track when showing Category Label Mapper should be shown
    this.importService.showHeaderMapper$.subscribe((x) => {
      this.showMapHeaders = x;
    });

    //Track Mapped Headers - SUPER ADMIN
    this.importService.mappedCategoryLabels$.subscribe((x) => {
      this.mappedHeaders = x;
    });

    //Track approved labels - Super Admin
    this.importService.approvedCatLabels$.subscribe((x) => {
      this.approvedLabels = x;
    });

    //Track mapped partner pros
    this.importService.mappedPartnerPros$.subscribe((x) => {
      this.mappedPartnerPros = x;
    });

    //Track import type
    this.importService.importType$.subscribe((x) => {
      this.importType = x;

      //check for existing mapping profile for selected pro type
      this.importService.getSavedMappingProfile(this.importType).subscribe(resProfile => {
        this.importService.setSavedProLabelMappingProfile(resProfile);
      });
    });


    //Track saved label mapping profile - used to pre populate values
    this.importService.savedProLabelMappingProfile$.subscribe((x) => {
      this.savedMappingProfile = x;
    })


  }

  /**
   * cancels the import process
   */
  cancelImport() {
    //reset all values in importService
    this.importService.resetImportProcess();

    //route back to start of import process
    this.router.navigate(['data/pro/']);

  }

  /**
   * Save function called for non super admin - MAY REQUIRED SOME TWEAKING
   */
  saveImport() {

    this.importService.setShowReadyToMap(true);

    this.importService.setImporterDetails(this.userService.currentUser);

  }



  /**
   * For Super Admin, this function will make sure all 
   * headers are mapped.  If so, it will navigate to the
   * "Ready to Map" view (for mapping data, not headers)
   */
  saveMappedHeaders() {
    this.mappingStart.emit();

    if (this.isMapping == false) {
      if (this.userService?.currentUser?.is_superuser) { //&& this.showMapHeaders(  {
        //we are calling save from super-admin-pro-map-labels view
  
  
        //this will be set to false if any labels are not mapped
        let fullyMapped = true;
  
        //7/29/24 - Turning this off for now.  All approved labels will NOT be used anymore since they are a
        //collection from all import types
  
        // //now iterate through the approvedLabels to ensure each one has been assigned
        // for (let i = 0; i < this.approvedLabels.length; i++) {
        //   const label = this.approvedLabels[i];
  
        //   //check to see if the label has been mapped
        //   const mappingFound = this.mappedHeaders.some(header => header.mappedTo === label && header.isAssigned);
        //   if (!mappingFound) {
        //     fullyMapped = false; // If any label does not meet the condition, set fullyMapped to false
  
        //     //no need to continue
        //     break;
        //   }
  
        // }
  
        if (fullyMapped) {
          //store mapping profile and navigate to the next page
          this.importService.setShowReadyToMap(true);
  
          this.importService.setImporterDetails(this.userService.currentUser);
  
          //extract assigned headers
          // Filter mappedHeaders to include only isAssigned == true
          const assignedHeaders = this.mappedHeaders.filter(header => header.isAssigned);
  
          //saves the mapping profile for this instance
          this.isMapping = true;
          this.importService.saveMappingProfile(assignedHeaders, this.importedFilePath, this.userService.currentUser.id).subscribe(
            (resProfile) => {
              this.mappingEnd.emit();
              
              this.importService.setImportProMappedHeadersProfile(resProfile);


  
              //now - lets upsert the saved mapping profile for this PRO type
              if (this.savedMappingProfile) {
                //we are updating this mapping profile
  
                //clear existing mapped headers
                this.savedMappingProfile.mappedHeaders = [];
  
                //set updated by value
                this.savedMappingProfile.updatedById = this.userService.currentUser.id;
  
              }
              else {
                //we are creating a new mapping profile
  
                this.savedMappingProfile = new ProLabelMappingProfile();
                this.savedMappingProfile.proType = this.importType;
                this.savedMappingProfile.createdById = this.userService.currentUser.id;
                this.savedMappingProfile.updatedById = this.userService.currentUser.id;
                this.savedMappingProfile.mappedHeaders = []; // just to make sure it's ready to build
  
              }
  
              //add new assigned headers
              assignedHeaders.forEach(header => {
                let mappedHeader = new ProMappedHeaders();
                mappedHeader.mappedFrom = header.mappedFrom;
                mappedHeader.mappedTo = header.mappedTo;
  
                this.savedMappingProfile.mappedHeaders.push(mappedHeader);
              });
  
  
              //save new saved mapping profile
              this.importService.upsertMappingProfile(this.savedMappingProfile).subscribe(
                (resProfile) => {
                  this.snackbarService.showSnackBarMessage(`Mapping profile saved for ${this.importType}`, 'Close');
                },
                (error) => {
                  this.snackbarService.showSnackBarMessage(`Error occurred saving mapping profile for ${this.importType}`, 'Close', undefined, true);
                }
              )
  
              this.isMapping = false;
              this.router.navigate(['data/pro/ready-to-map']);
            },
            (error) => {
              this.snackbarService.showSnackBarMessage(`Error occurred mapping labels`, 'Close', undefined, true);
            });
  
  
  
  
        }
        else {
          //alert the user that mapping is not complete
          this.snackbarService.showSnackBarMessage("Category label mapping not complete!", 'Close', undefined, true);
  
        }
  
  
      }
    }

  }

  /**
   * Saves the ShowMapperProfile progress
   * so the user can come back later and complete
   * the process
   */
  saveMappingProgress(){
    if (this.isMapping == false) {
      let showMapperProfile = new ShowMapperProfile();
  
      this.isMapping = true;
      //test code for reaching api
      this.importService.createShowMapperProfile(showMapperProfile).subscribe(resShowMapperProfile => {
        var test = resShowMapperProfile;
        this.isMapping = false;
      })
    }
  }


  /**
   * Should only be called by Super Admin.
   * This is the ultimate save call which
   * will map the data and calculate the 
   * Partner Splits
   */
  saveAndMapShows() {
    console.log("Save And Map Shows called")

    if (this.mappedPartnerPros.some(item => item.isMapped === undefined || item.isMapped === false)) {
      this.snackbarService.showSnackBarMessage('You must map all shows to continue.', 'Close', undefined, true);
    }
    else {


      this.mappedPartnerPros.forEach(pro => {

        //add mapToShow to list of shows for partnerGroup if it does not already exist in the list
        pro.selectedGroups.forEach(group => {
          if (!group.shows.includes(pro.mapToShow)) {
            group.shows.push(pro.mapToShow)
          }
          //save Partner Group
          this.partnerService.updatePartnerGroup(group).subscribe(
            (resGroup) => {
              //navigate to the archive
              this.router.navigate(['/data/pro/archive']);
            },
            (error) => {
              this.snackbarService.showSnackBarMessage('An error occurred updating the Partner Group', 'Close', undefined, true);
            }
          )
        });
      })


    }
  }

  requestApproval() {
    if (this.mappedPartnerPros.every(item => item.isMapped === true)) {
      // save and submit approval request

      //open modal to display progress
      const dialogRef = this.dialog.open(ImportingSelectionsModalComponent, {
        // width: '800px',
        // height: '400px',
        // data: { anyDataYouWantToPass: 'example' } // If you need to pass data
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');

        // this.partnerService.getPartnerGroups().subscribe((x) => {
        //   this.partnerService.setPartnerGroups(x);
        // });

      });

    }
    else {
      const dialogRef = this.dialog.open(MapAllShowsErrorModalComponent, {
        // width: '800px',
        // height: '400px',
        // data: { anyDataYouWantToPass: 'example' } // If you need to pass data
      });

      dialogRef.afterClosed().subscribe(result => {
        console.log('The dialog was closed');

        // this.partnerService.getPartnerGroups().subscribe((x) => {
        //   this.partnerService.setPartnerGroups(x);
        // });

      });
    }
  }

}
